<div class="layout-wrapper layout-menu-horizontal" (click)="onLayoutClick()"
    [ngClass]="{'layout-mobile-active': overlayMenuMobileActive}">

    <app-topbar></app-topbar>

    <!-- <app-menu></app-menu> -->

    <app-actionbar></app-actionbar>

    <div class="layout-content">
        <p-toast position="top-right"></p-toast>
        <p-confirmDialog header="Confirm" icon="pi pi-exclamation-triangle"></p-confirmDialog>
        <!-- <p-dialog></p-dialog> -->
        <router-outlet></router-outlet>

    </div>

    <app-footer></app-footer>

</div>